import React from 'react'
import './guideStyles.css'
import Block from './components/Block'

// admin screens
// data
import QuestionTypesData from './data/QuestionTypes.json'
import IntroductionData from './data/admin/Introduction.json'
import RolesData from './data/admin/Roles.json'
import FeaturesData from './data/admin/Features.json'
import BenefitsData from './data/admin/Benefits.json'
import StudentsListData from './data/admin/StudentsList.json'
import AddStudentData from './data/admin/AddStudent.json'
import UploadStudentsCSVData from './data/admin/UploadStudentsCSV.json'
import UploadStudentsPreviewData from './data/admin/UploadStudentsPreview.json'
import TopicsData from './data/admin/Topics.json'
import SchedulesData from './data/admin/Schedules.json'
import AddSchedulesData from './data/admin/AddSchedules.json'
import InterviewsData from './data/admin/Interviews.json'

// teachers data
import TeachersTopicsData from './data/teacher/Topics.json'
import QuestionManagamentData from './data/teacher/QuestionManagament.json'

// images
import loginImage from './images/login.png'
import dashboardImage from './images/admin/dashboard.png'
import collegesImage from './images/admin/colleges.png'
import addCollegeImage from './images/admin/addCollege.png'
import editCollegeImage from './images/admin/editCollege.png'
import batchesImage from './images/admin/batches.png'
import addBatchImage from './images/admin/addBatch.png'
import editBatchImage from './images/admin/editBatch.png'
import studentsImage from './images/admin/students.png'
import studentsBatchFilterImage from './images/admin/studentsBatchFilter.png'
import addStudentImage from './images/admin/addStudent.png'
import editStudentImage from './images/admin/editStudent.png'
import addStudentsBulkImage from './images/admin/addStudentsBulk.png'
import uploadStudentsPreview from './images/admin/uploadStudentsPreview.png'
import subjectsImage from './images/admin/subjects.png'
import addSubjectsImage from './images/admin/addSubject.png'
import editSubjectsImage from './images/admin/editSubject.png'
import teachersImage from './images/admin/teachers.png'
import addTeacherImage from './images/admin/addTeacher.png'
import editTeacherImage from './images/admin/editTeacher.png'
import topicsImage from './images/admin/topics.png'
import addTopicImage from './images/admin/addTopic.png'
import editTopicImage from './images/admin/editTopic.png'
import schedulesImage from './images/admin/schedules.png'
import AddScheduleImage from './images/admin/AddSchedule.png'
import InterviewsImage from './images/admin/Interviews.png'
import EvaluationReportImage from './images/admin/EvaluationReport.png'
import ResetPasswordImage from './images/admin/resetPassword.png'

// teacherimages
import WorkflowImage from './images/teacher/workflow.png'
import SubjectsImage from './images/teacher/subjects.png'
import TopicsImage from './images/teacher/topics.png'
import CreateTopicImage from './images/teacher/createTopic.png'
import ImportTopicImage from './images/teacher/ImportTopic.png'
import SelectTopicImage from './images/teacher/selectTopic.png'
import AutoGenerateImage from './images/teacher/autoGenerate.png'
import ImportQuestionsImage from './images/teacher/importQuestions.png'
import PreviewImage from './images/teacher/preview.png'
import AddVivaQImage from './images/teacher/addVivaQuestion.png'
import EditVivaQImage from './images/teacher/editVivaQuestion.png'
import AddTheoryQImage from './images/teacher/addTheoryQuestion.png'
import EditTheoryQImage from './images/teacher/editTheoryQuestion.png'
import AddCodeQImage from './images/teacher/AddCodeQuestion.png'
import AddDebugQImage from './images/teacher/addDebugCode.png'
import AddJumbledQImage from './images/teacher/addJumbledQuestion.png'
import AddExplainQImage from './images/teacher/addExplainQuestion.png'
import AddPredictOutputQImage from './images/teacher/addPredictOutput.png'
import AddedQuestionsListImage from './images/teacher/AddedQuestionsList.png'
import FreezeQuestionsImage from './images/teacher/freezeQuestions.png'
import ExportTopicImage from './images/teacher/exportTopic.png'

// containers
import ListBlock from './components/ListBlock'
import ListBlockWithTitle from './components/ListBlockWithTitle'
import UserGuideImage from './components/UserGuideImage'

export default function UserGuide() {
    return (
        <div style={{ margin: 0, padding: 0 }}>
            <div className='guide-container'>
                <h1 className='title'>Prashnamanch</h1>
                <Block
                    id="introduction"
                    header={IntroductionData.header}
                    content={IntroductionData.content}
                    subHeaders={IntroductionData.subHeaders}
                />
                <Block
                    id="roles"
                    header={RolesData.header}
                    content={RolesData.content}
                    subHeaders={RolesData.subHeaders}
                />
                <ListBlock
                    id="features"
                    header={FeaturesData.header}
                    content={FeaturesData.content}
                    subHeaders={FeaturesData.subHeaders}
                />
                <ListBlockWithTitle
                    id="benefits"
                    header={BenefitsData.header}
                    list={BenefitsData.list}
                />

                <div id='admin-workflows'>
                    <h2 className='header'>Admin Workflows</h2>
                    <div>
                        <UserGuideImage
                            header={'1. Login'}
                            content={'Login into the portal by using given credentials (username and password)'}
                            imageUrl={loginImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="2. Dashboard"
                            content={`
                                Dashboard aim to provide a comprehensive summary of today's activities and overall performance metrics. 
                                This information is designed to give users a clear and concise overview of their engagement and progress 
                                within the application. The summary includes key performance indicators such as the total time spent, 
                                the number of questions answered, the average score, the total number of interviews taken, the number of 
                                students involved, and the total subjects covered. This data helps users track their progress, identify areas 
                                for improvement, and stay motivated to achieve their learning goals.`
                            }
                            imageUrl={dashboardImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header={'3. Colleges'}
                            content={'Displays a comprehensive list of all colleges that have been added to the system. This list typically includes details such as college names and college codes.'}
                            imageUrl={collegesImage}
                        />
                        <UserGuideImage
                            header={'3.1 Add College'}
                            content={'Provides a form for adding new colleges. The form include fields like college code and college name.'}
                            imageUrl={addCollegeImage}
                        />
                        <UserGuideImage
                            header={'3.2 Edit College'}
                            content={'Provides a form for modifying existing college. The form include fields like college code and college name.'}
                            imageUrl={editCollegeImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header={'4. Batches'}
                            content={'A "batch" refers to a group of students who are admitted to a particular course. Displays a comprehensive list of all batches that have been added to the system.'}
                            imageUrl={batchesImage}
                        />
                        <UserGuideImage
                            header={'4.1 Add Batch'}
                            content={'Provides a form for adding new batch. The form include batch name.'}
                            imageUrl={addBatchImage}
                        />
                        <UserGuideImage
                            header={'4.2 Edit Batch'}
                            content={'Provides a form for modifying existing batch. The form include batch name.'}
                            imageUrl={editBatchImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header={'5. Students'}
                            content={`
                                This interface designed to manage and organize student information efficiently.
                                It provides several key features to facilitate the administration and tracking of student data.
                            `}
                            list={StudentsListData.list}
                            imageUrl={studentsImage}
                        />
                        <UserGuideImage
                            header={'5.1 Filter batches'}
                            content={`The "Filter" option in the student list table allows users to view students from specific batches.
                            This feature is highly flexible, enabling users to select and display students from one or multiple batches simultaneously.
                            It streamlines the process of managing and analyzing student data based on batch-specific criteria.`}
                            imageUrl={studentsBatchFilterImage}
                        />
                        <UserGuideImage
                            header={'5.2 Add Individual Student'}
                            list={AddStudentData.list}
                            imageUrl={addStudentImage}
                        />
                        <UserGuideImage
                            header={'5.3 Edit Student'}
                            content={`This feature allows user to update various aspects of a student's data. This includes updating the student's name,
                             adding the student to another batch, and removing the student from an existing batch.`}
                            imageUrl={editStudentImage}
                        />
                        <UserGuideImage
                            header={'5.4 Upload using CSV'}
                            list={UploadStudentsCSVData.list}
                            imageUrl={addStudentsBulkImage}
                        />
                        <UserGuideImage
                            header={'5.4.1 Preview'}
                            list={UploadStudentsPreviewData.list}
                            imageUrl={uploadStudentsPreview}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header={'6. Subjects'}
                            content={`
                                This interface designed to manage and organize subject information efficiently.                                
                            `}
                            imageUrl={subjectsImage}
                        />
                        <UserGuideImage
                            header={'6.1 Add Subject'}
                            content={`Provides a form to add subject manually.`}
                            imageUrl={addSubjectsImage}
                        />
                        <UserGuideImage
                            header={'6.2 Edit Subject'}
                            content={`This feature allows user to update the subject information `}
                            imageUrl={editSubjectsImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header={'7. Teachers'}
                            content={`
                            It provides a comprehensive list of all teachers. This page allows users to efficiently manage and review teacher information, including their assigned subjects. To view their assigned subjects, user has to expand the row.
                            `}
                            imageUrl={teachersImage}
                        />
                        <UserGuideImage
                            header={'7.1 Add Teacher'}
                            content={`
                                This feature allows user to add new teacher. The each item in the subjects dropdown is combination of subject and batch, this can assign subject to the teacher and teacher to the batch in one go. 
                            `}
                            imageUrl={addTeacherImage}
                        />
                        <UserGuideImage
                            header={'7.2 Edit Teacher'}
                            content={`
                            This feature allows user to update various aspects of a teacher's data. This includes updating the teacher's name,
                            assigning new subject, and removing the assigned subject.
                            `}
                            imageUrl={editTeacherImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header={'8. Topics'}
                            content={`
                            It provides a comprehensive list of topics, each associated with a specific subject. This page includes functionalities that allow 
                            users to filter the displayed topics based on the selected subject. Additionally, there is a special field associated with each topic called "status".
                            `}
                            list={TopicsData.list}
                            imageUrl={topicsImage}
                        />
                        <UserGuideImage
                            header={'8.1 Add Topic'}
                            content={`
                            The "Add Topic" feature allows users to add a new topic to a selected subject.
                            `}
                            imageUrl={addTopicImage}
                        />
                        <UserGuideImage
                            header={'8. Edit Topic'}
                            content={`
                                User have the option to change the name of the selected topic, switch topic between subjects and can change the status of a topic.
                            `}
                            imageUrl={editTopicImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header={'9. Schedules'}
                            content={`
                            The "Schedules" feature manages the scheduling, administration, and completion of interviews. 
                            This feature ensures that interviews are conducted efficiently, tracked accurately.
                            `}
                            list={SchedulesData.list}
                            imageUrl={schedulesImage}
                        />
                        <UserGuideImage
                            header={'9.1 New Schedule'}
                            list={AddSchedulesData.list}
                            imageUrl={AddScheduleImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header={'10. Interviews'}
                            content={`
                            The Interviews page provides users with a detailed interface to manage and review student interviews. 
                            It includes features for selecting interview schedules, filtering interviews by status, and viewing detailed evaluation reports.
                             Additionally, users can filter student lists based on their attendance and performance.
                            `}
                            list={InterviewsData.list}
                            imageUrl={InterviewsImage}
                        />
                        <UserGuideImage
                            header={'10.1 Evaluation Report'}
                            content={`
                            The interview evaluation section allows users to thoroughly review student responses, including written answers and 
                            audio recordings. Additionally, users can view scores and feedback for each individual question. There is also an 
                            option to export this information in PDF format for record-keeping and further analysis.
                            `}
                            imageUrl={EvaluationReportImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header={'11. Reset Password'}
                            content={`
                            The reset password page is designed for administrators to manage and update the usernames and passwords of both students and teachers. 
                            This functionality ensures that users can regain access to their accounts in case they forget their passwords or need to 
                            update them for security reasons.
                            `}
                            imageUrl={ResetPasswordImage}
                        />
                    </div>
                </div>

                <div id='teacher-workflows'>
                    <h2 className='header'>Teacher Workflows</h2>
                    <div>
                        <UserGuideImage
                            imageUrl={WorkflowImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header={'1. Login'}
                            content={'Login into the portal by using given credentials (username and password)'}
                            imageUrl={loginImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="2. Subjects"
                            content={`
                            The Teacher Dashboard provides a comprehensive overview of the subjects a teacher is 
                            responsible for. This section is designed to offer quick and insightful access to subject-specific information. 
                            Displays the total number of topics in a subject and total number of questions associated with each subject.
                            Click on a subject to get list of topics`
                            }
                            imageUrl={SubjectsImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="3. Topics"
                            content={`
                            The Topics Page is designed to provide users with a seamless experience in managing educational topics. 
                            This page includes features to create new topics, import topics from an exported ZIP file, and select existing topics for further actions.`
                            }
                            // list={TeachersTopicsData.list}
                            // listType={"headers"}
                            imageUrl={TopicsImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="3.1 Create New Topic"
                            content={'Questions are auto-generated based on topic name so please avoid invalid topic names like Interview1, Test, EliteInterview, CSE-A-Test'}
                            list={TeachersTopicsData.list[0].list}
                            imageUrl={CreateTopicImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="3.2 Import Topic"
                            list={TeachersTopicsData.list[1].list}
                            imageUrl={ImportTopicImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="3.3 Select Topic"
                            list={TeachersTopicsData.list[2].list}
                            imageUrl={SelectTopicImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="4. Auto Generate"
                            content={`This option allows you to automatically generate a specified number of viva-type questions. Viva questions are oral 
                            questions used to assess a student's understanding of a subject. Selecting this option will streamline the process of creating 
                            these questions, ensuring you have a ready set of questions without manually drafting each one.`}
                            imageUrl={AutoGenerateImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="5. Import Questions"
                            content={`This option lets you import questions from an external CSV file. The CSV file can contain both Viva-type (oral) and 
                            Theory-type (written) questions. This feature is useful for integrating a pre-existing set of questions into the system.`}
                            imageUrl={ImportQuestionsImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="5.1 Preview Questions"
                            imageUrl={PreviewImage}
                        />
                    </div>
                    <div>
                        <Block
                            subHeaders={QuestionTypesData.questionTypes}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="6.1 Add VIVA type Question"
                            content={``}
                            list={QuestionManagamentData.list[0].list}
                            imageUrl={AddVivaQImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="6.2 Edit VIVA type Question"
                            content={``}
                            list={QuestionManagamentData.list[1].list}
                            imageUrl={EditVivaQImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="6.3 Add THEORY type Question"
                            content={``}
                            list={QuestionManagamentData.list[2].list}
                            imageUrl={AddTheoryQImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="6.4 Edit THEORY type Question"
                            content={``}
                            list={QuestionManagamentData.list[3].list}
                            imageUrl={EditTheoryQImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="6.5 Add CODE type Question"
                            content={``}
                            list={QuestionManagamentData.list[4].list}
                            imageUrl={AddCodeQImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="6.6 Add DEBUG CODE type Question"
                            content={``}
                            list={QuestionManagamentData.list[5].list}
                            imageUrl={AddDebugQImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="6.7 Add JUMBLED CODE type Question"
                            content={``}
                            list={QuestionManagamentData.list[6].list}
                            imageUrl={AddJumbledQImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="6.8 Add EXPLAIN CODE type Question"
                            content={``}
                            list={QuestionManagamentData.list[7].list}
                            imageUrl={AddExplainQImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="6.8 Add PREDICT OUTPUT type Question"
                            content={``}
                            list={QuestionManagamentData.list[8].list}
                            imageUrl={AddPredictOutputQImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="7. List of Questions"
                            content={`The questions are displayed in a comprehensive list, with several key features for managing them effectively:`}
                            list={QuestionManagamentData.list[9].list}
                            imageUrl={AddedQuestionsListImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="8. Freeze Questions"
                            content={`There is a feature to freeze all the questions in the list. Freezing questions means no further modifications can be made to them. This is useful for finalizing the list of questions for an interview.`}                            
                            imageUrl={FreezeQuestionsImage}
                        />
                    </div>
                    <div>
                        <UserGuideImage
                            header="9. Export Topic"
                            content={`The export topic feature allows you to export all types of questions that exist within a specific topic. 
                            This includes viva, theory, code, debug code, jumbled code, predict output and explain code questions, along with the topic name. 
                            This functionality is particularly useful for creating a portable package of your topic that can be easily shared and later 
                            imported back into the system with all its content intact. "A topic cannot be exported before freeze".`}                            
                            imageUrl={ExportTopicImage}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
